import { Tabs } from 'antd';
import React from 'react';
import VideoChapters from './VideoChapters';

const VideoSubjects = ({ courseSubjects }) => {
  // console.log(courseSubjects);
  return (
    <Tabs
      title="Subjects"
      defaultActiveKey="1"
      tabPosition={'left'}
      items={
        courseSubjects &&
        courseSubjects.map((subject, index) => {
          return {
            label: subject.subjectName,
            key: index + 1,
            children: <VideoChapters subjectChapters={subject && subject.chapters ? subject.chapters : []} />,
          };
        })
      }
    ></Tabs>
  );
};

export default VideoSubjects;
